import { render, staticRenderFns } from "./FeesNoticeDetailsDeductionsTable.vue?vue&type=template&id=19988444"
import script from "./FeesNoticeDetailsDeductionsTable.vue?vue&type=script&lang=js"
export * from "./FeesNoticeDetailsDeductionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports